import Base from "./Base";

export default Base;
